const getSliderSide = (
  isNext: boolean,
  isPrev: boolean,
): 'left' | 'right' | null => {
  return isNext ? 'right' : isPrev ? 'left' : null;
};

export { getSliderSide };
